import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AccountManager } from '../../../../managers/account.manager';
import { LexbeCase } from '../../../../models/case.model';
import { Account } from '../../../../models/ui/account.model';

@Component({
    selector: 'lex-create-case-dialog',
    templateUrl: './create-case-dialog.component.html',
    styleUrls: ['./create-case-dialog.component.scss'],
    standalone: false
})
export class CreateCaseDialogComponent {

	public showAccount: boolean = false;
	public accounts$: Observable<Account[]>;
	public selectedAccountId: string;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<CreateCaseDialogComponent>,
		private accountManager: AccountManager,
		@Inject(MAT_DIALOG_DATA) private data: string) {
		if (!this.data) {
			this.accounts$ = this.accountManager.accountCollection$;
			this.accountManager.refreshAdminAccounts();
			this.showAccount = true;
			this.newCaseForm = this.formBuilder.group({
				account: [data , Validators.required],
				caseName: ['', [Validators.required, Validators.maxLength(256)]]
			});
		}
		else {
			this.newCase.accountId = data;
			this.newCaseForm = this.formBuilder.group({
				caseName: ['', [Validators.required, Validators.maxLength(256)]]
			});
		}
	}

	public newCaseForm: UntypedFormGroup;
	private newCase = {
		caseName: '',
		caseNumber: '',
		caseType: '',
		caseVenue: '',
		leadAttorney: '',
		trierOfFact: '',
		caseComments: ''
	} as LexbeCase;

	public addNewCase(): void {
		this.newCase.caseName = this.newCaseForm.controls['caseName'].value;
		if(this.showAccount)
			this.newCase.accountId = this.newCaseForm.controls['account'].value;
		this.dialogRef.close(this.newCase);
	}
}
